import * as React from 'react';
import { UIText2 } from '@cian/ui-kit';

import * as styles from './LocationPopoverList.css';

export interface ILocationItem {
  id: number;
  label: string;
}

interface ILocationPopoverListProps {
  options: ILocationItem[];
  onItemClick(option: ILocationItem): void;
}

export const LocationPopoverList: React.FC<ILocationPopoverListProps> = ({ options, onItemClick }) => {
  return (
    <div className={styles['wrapper']}>
      <ul className={styles['container']} data-testid="LocationPopoverList">
        {options.map(option => {
          const { label, id } = option;

          return (
            <li className={styles['item']} key={id} onClick={() => onItemClick(option)}>
              <UIText2>{label}</UIText2>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
